import { render, staticRenderFns } from "./PageAdminSyncProfileFieldMappings.vue?vue&type=template&id=aa1e80aa"
import script from "./PageAdminSyncProfileFieldMappings.vue?vue&type=script&lang=js"
export * from "./PageAdminSyncProfileFieldMappings.vue?vue&type=script&lang=js"
import style0 from "./PageAdminSyncProfileFieldMappings.vue?vue&type=style&index=0&id=aa1e80aa&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports